import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerGroupSelectComponent } from './customer-group-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [CustomerGroupSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [CustomerGroupSelectComponent],
})
export class CustomerGroupModule {}
